import { render } from "./EventResultRankTable.vue?vue&type=template&id=4d4210ae&scoped=true"
import script from "./EventResultRankTable.vue?vue&type=script&lang=js"
export * from "./EventResultRankTable.vue?vue&type=script&lang=js"

import "./EventResultRankTable.vue?vue&type=style&index=0&id=4d4210ae&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4210ae"]])

export default __exports__